import { render, staticRenderFns } from "./AlarmRuleModal.vue?vue&type=template&id=97ff1ac0&scoped=true"
import script from "./AlarmRuleModal.vue?vue&type=script&lang=js"
export * from "./AlarmRuleModal.vue?vue&type=script&lang=js"
import style0 from "./AlarmRuleModal.vue?vue&type=style&index=0&id=97ff1ac0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ff1ac0",
  null
  
)

export default component.exports